<template>
  <div class="service-root-container">
    <span class="service-title">服务协议</span>
    <slide-tabber
      style="align-self: center; margin-bottom: 20px"
      :tabs="tabs"
      @on-change="onBarChange"
    />
    <service-item
      v-for="service in serviceList"
      :key="service.id"
      :data-source="service"
    />
  </div>
</template>

<script>
import moment from "moment";
import ServiceItem from "../Item/ServiceItem";
import SlideTabber from "../../../components/SlideTabbar";
import MyAvatar from "../../../components/MyAvatar";
import * as icon from "../../../common/icon";
import { mapActions } from "vuex";
export default {
  components: {
    "my-avatar": MyAvatar,
    "slide-tabber": SlideTabber,
    "service-item": ServiceItem,
  },
  data() {
    return {
      icons: icon,
      tabs: [
        {
          name: "生效中的",
          count: 0,
        },
        {
          name: "待签署的",
          count: 0,
        },
        {
          name: "已过期的",
          count: 0,
        },
      ],
      currentIndex: 0,
      service_wait_list: [],
      service_valid_list: [],
      service_over_list: [],
    };
  },
  mounted() {
    this.company_id = this.$route.params.company_id;

    this.employerGetServiceAction({
      employer_id: localStorage.getItem("employer_id"),
      company_id: this.company_id,
    })
      .then((res) => {
        // type 1=待签署 2=生效中 3=已过期
        this.service_wait_list = [];
        this.service_valid_list = [];
        this.service_over_list = [];
        for (let item of res.data.list) {
          let arr = [];
          if (item.type == 1) {
            arr = this.service_wait_list;
          } else if (item.type == 2) {
            arr = this.service_valid_list;
          } else {
            arr = this.service_over_list;
          }
          arr.push({
            id: item.id,
            state: item.type,
            name: item.contract_name,
            year: item.end_time
              ? moment(item.end_time).diff(moment(item.start_time), "years")
              : "-",
            start_time: moment(item.start_time).format("YYYY-MM-DD"),
            end_time: item.end_time
              ? moment(item.end_time).format("YYYY-MM-DD")
              : "-",
            view_url: item.view_url,
            count: item.count,
          });
        }
      })
      .catch((error) => {
        this.$Message.error(error);
      });
  },
  methods: {
    ...mapActions({
      employerGetServiceAction: "employerGetService",
    }),
    onBarChange(index) {
      this.currentIndex = index;
    },
  },
  computed: {
    serviceList: function () {
      if (this.currentIndex == 0) {
        return this.service_valid_list;
      } else if (this.currentIndex == 1) {
        return this.service_wait_list;
      } else {
        return this.service_over_list;
      }
    },
  },
};
</script>

<style scoped>
.service-root-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 20px;
  background-color: #fff;
  border-radius: 14px;
}
.service-title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-left: 20px;
}
.service-company-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
.service-company-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 15px 20px;
}
</style>